var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadiationSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3E4F64;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.1,370.1c-1.1-1.7-3.4-2.2-5.1-1.1c-29.4,17.4-57.5,6.3-68.9,0.2c-1.8-1-4-0.4-4.9,1.4l-66.6,111.9 c-1.1,1.9-0.4,4.2,1.4,5.2c102.6,56.3,190.7,9.1,212.3-4.5c1.8-1.1,2.3-3.4,1.1-5.2L341.1,370.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.4,293.6c-0.4-34.1,23.4-52.9,34.3-59.7c1.7-1.1,2.3-3.3,1.3-5l-63.7-113.6c-1.1-1.9-3.4-2.5-5.2-1.3 C90,174.5,86.8,274.6,87.8,300c0.1,2.1,1.9,3.7,4,3.6c19.4-1,108.8-5.3,128.1-6.3C221.9,297.3,223.4,295.6,223.4,293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404.6,113.5c-1.9-1-4.1-0.3-5.1,1.6l-58.6,114.1c-1,1.9-0.3,4,1.5,5c29.7,16.8,34.1,46.6,34.6,59.5 c0.1,2,1.7,3.6,3.7,3.6l130.2,1.7c2.1,0,3.9-1.8,3.8-3.9C512.2,178,427.2,125.4,404.6,113.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.5,347c26.2,0,47.4-21.3,47.4-47.4c0-26.2-21.3-47.4-47.4-47.4c-26.2,0-47.4,21.3-47.4,47.4 C252.1,325.7,273.3,347,299.5,347z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.5,45.2C159.7,45.2,46,158.8,46,298.7s113.8,253.5,253.5,253.5S553,438.5,553,298.7S439.3,45.2,299.5,45.2 z M299.5,536.8C168.2,536.8,61.4,430,61.4,298.7S168.2,60.6,299.5,60.6s238.1,106.8,238.1,238.1 C537.6,429.9,430.8,536.8,299.5,536.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiationSymbol);
export default __webpack_public_path__ + "static/media/radiation-symbol.67df9c462fb97c502afcb618f258b0df.svg";
export { ForwardRef as ReactComponent };